import axios from 'axios';
import showOrHidden from './showOrHidden'

const state = {
    cadastro: [],
    planos: []
}
const getters = {
    getCadastro: state => state.cadastros,
    getPlans: state => state.planos,
}

const mutations = {
    allCadastro: (state, cadastro) => (state.cadastro = cadastro),
    searchPlan: function(state, planos) {
        state.planos = planos
        return "foi";
	},
	closeModal: function(state){
		showOrHidden.actions.setModalCadastro(this, [])
	}

}

const actions = {
    async saveCadastro({ commit }, data) {
        axios.post('/save_attendance', data)
            .then(function(response) {
				console.log(response);
				Swal.fire({
					type: 'success',
					text: 'Atendimento cadastrado com sucesso'
				});
				document.getElementById("form-cadastro").reset();
				commit('closeModal');
            })
            .catch(function(error) {
                console.error(error);
				Swal.fire({
					type: 'error',
					text: 'Não foi possivel salvar o atendimento'
				});
            });
    },
    async searchPlan({ commit }) {
        const response = await axios.get('/search_plan');
        if (response.status == '200') commit('searchPlan', response.data);
    }
}
export default {
    getters,
    mutations,
    actions,
    state
}
